import { Action, ActionCreator } from 'redux';

export enum LocalStatusActionTypes {
    SET_MUTATION_VALIDATION_DIALOG_OPEN = 'SET_MUTATION_VALIDATION_DIALOG_OPEN',
    SET_UNSAVED_DATA_ACTION = 'SET_UNSAVED_DATA_ACTION',
    SET_TO_DIRTY = 'SET_TO_DIRTY',
    SET_TO_IDLE = 'SET_TO_IDLE',
    SET_MUTATION_IN_PROGRESS = 'SET_MUTATION_IN_PROGRESS',
}

export interface SetMutationInProgress extends Action {
    type: LocalStatusActionTypes.SET_MUTATION_IN_PROGRESS;
    payload: {
        open: boolean;
    };
}

export interface SetMutationValidationDialogOpen extends Action {
    type: LocalStatusActionTypes.SET_MUTATION_VALIDATION_DIALOG_OPEN;
    payload: {
        open: boolean;
    };
}

export interface SetUnsavedDataAction extends Action {
    type: LocalStatusActionTypes.SET_UNSAVED_DATA_ACTION;
    payload: {
        action?: () => void;
    };
}

export interface SetToDirty extends Action {
    type: LocalStatusActionTypes.SET_TO_DIRTY;
    payload: {
        setToDirty: boolean;
    };
}

export interface SetToIdle extends Action {
    type: LocalStatusActionTypes.SET_TO_IDLE;
    payload: {
        isIdle: boolean;
    };
}

export type LocalStatusActions =
    | SetMutationValidationDialogOpen
    | SetUnsavedDataAction
    | SetMutationInProgress
    | SetToIdle
    | SetToDirty;

export const setMutationInProgress: ActionCreator<SetMutationInProgress> = (open: boolean) => {
    return {
        type: LocalStatusActionTypes.SET_MUTATION_IN_PROGRESS,
        payload: {
            open,
        },
    };
};

export const setUnsavedDataAction: ActionCreator<SetUnsavedDataAction> = (action?: () => void) => {
    return {
        type: LocalStatusActionTypes.SET_UNSAVED_DATA_ACTION,
        payload: {
            action,
        },
    };
};

export const setToDirty: ActionCreator<SetToDirty> = (isDirty: boolean) => {
    return {
        type: LocalStatusActionTypes.SET_TO_DIRTY,
        payload: {
            setToDirty: isDirty,
        },
    };
};

export const setIdle: ActionCreator<SetToIdle> = (isIdle: boolean) => {
    return {
        type: LocalStatusActionTypes.SET_TO_IDLE,
        payload: {
            isIdle,
        },
    };
};
